// ScrollLock is used to stop propagation of the mouse wheel event to parent elements when
// the element is scrolled to the top or bottom.
// Usage - Set scrollLock as the `onWheel` event handler on the element that has overflow.

export function scrollLockCore(ev, element) {
  let delta =
    ev.type === 'wheel' ? ev.nativeEvent.wheelDelta || ev.nativeEvent.deltaY * -1 : ev.nativeEvent.detail * -40;
  // negative delta just means we are scrolling down
  if (delta < 0 && element.scrollHeight - element.offsetHeight - element.scrollTop <= 0) {
    element.scrollTop = element.scrollHeight;
    ev.preventDefault();
  } else if (delta > 0 && delta > element.scrollTop) {
    element.scrollTop = 0;
    ev.preventDefault();
  }
}

export default function(ev) {
  const element = ev.currentTarget;
  ev.stopPropagation();
  scrollLockCore(ev, element);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/util/scroll_lock_handler.js